import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  Input,
  OnInit,
} from "@angular/core";
import { InLinePumps } from "../../../shared/data-objects/inLine-pumps";
import { SelectItem } from "primeng/api";
import {
  WorkrequestGreenField,
  WorkrequestPsaDetails,
} from "../workrequest-psa-details";
import { FormControl, Validators } from "@angular/forms";
import { PsaService } from "../psa.service";
import { LoginService } from "../../../shared/services/login.service";
import { RefDataService } from "../../../shared/services/ref-data.service";
import { ServiceBase } from "../../../shared/services/service-base";
import {
  RefDataItem,
  RefDataType,
} from "../../../shared/data-objects/ref-data-item";

const specialCharRE = /^[a-zA-Z0-9-()'#.,&\s \\ \/]+$/;

@Component({
  selector: "app-workrequest-psa",
  templateUrl: "./workrequest-psa.component.html",
  styleUrls: ["./workrequest-psa.component.css"],
})
export class WorkrequestPsaComponent implements OnInit {
  greenField: boolean = false;
  brownField: boolean = false;
  recycleWaterSelectedR: boolean;
  descriptionOfWorkControlMaxLength = 8000;

  recycleServiceSizeValues: any;
  waterServiceSizeValues: any;
  generalServiceSizeValues: any;

  pumpCurveOptions: any[];
  waterSupplyOptions: any[];
  fireServiceSize: any;

  errorMessage: any[];
  @Input() workRequestPsa: WorkrequestPsaDetails;
  @Input() workrequestGreenField: WorkrequestGreenField;
  @Input()
  isReadOnly = false;
  isReadOnlyPumps: boolean = false;
  selectedRows: any;

  serviceSingleR: any;
  generalServiceSingleR: any;
  inLinePumpR: any;
  brownFielddevelopmentTypeR: any;
  greenFielddevelopmentTypeR: any;
  sewerPumpR: any;
  selectedRow: any[];
  totalLots: number = 0;

  inLinePumpList: InLinePumps[];
  inLinePumpListR: InLinePumps[];
  displayRecycleWater: boolean = false;
  waterServicedisplay: number;
  fireServicedisplay: number;
  generalServicedisplay: number;

  shouldDisplayCurveTable: boolean = false;
  shouldDisplayCurveTableRecycle: boolean = false;
  fireService: any;
  typeOfService: any[];

  singleCommercialControl: FormControl;
  residentialControl: FormControl;
  commercialControl: FormControl;
  resiCommercialControl: FormControl;

  numberOfLevelsControl: FormControl;
  noOfBasementsControl: FormControl;
  residentialLotsControl: FormControl;
  industrialLotsControl: FormControl;
  commercialLotsControl: FormControl;
  descriptionControl: FormControl;

  waterServiceSizeControl: FormControl;
  hydrantFlowRateControl: FormControl;
  sprinklerFlowRateControl: FormControl;
  generalServiceSizeControl: FormControl;
  generalFlowRateControl: FormControl;

  recycledServiceSizeControl: FormControl;
  demandControl: FormControl;

  totalSewerLoadingControl: FormControl;
  fixtureQuantityControl: FormControl;
  nonResidentialFloorSpaceControl: FormControl;

  residentialLotsGreenFieldControl: FormControl;
  residentialdwellingsControl: FormControl;
  residentialunitsControl: FormControl;
  commercialLotsHectorsControl: FormControl;
  warehouseHectaresControl: FormControl;
  manfcHectaresControl: FormControl;
  storeHectaresControl: FormControl;

  constructor(
    private psaService: PsaService,
    private loginService: LoginService,
    private refDataService: RefDataService
  ) {
    this.psaService.onDevelopmentChange.subscribe((x) => {
      if (this.psaService.applicationData.planType === "BrownField") {
        this.brownField = true;
        this.greenField = false;
      }
      if (this.psaService.applicationData.planType === "GreenField") {
        this.greenField = true;
        this.brownField = false;
      }
    });

    this.psaService.onBrownFielddevelopmentTypeSelection.subscribe((v) => {
      this.brownFielddevelopmentTypeR = v;
    });
    this.psaService.onGreenFielddevelopmentTypeSelection.subscribe((v) => {
      this.greenFielddevelopmentTypeR = v;
    });

    this.psaService.onInLinePumpSelection.subscribe((v) => {
      this.inLinePumpR = v;
    });

    this.psaService.onServiceSingleSelection.subscribe((v) => {
      this.serviceSingleR = v;
    });

    this.psaService.onGeneralServiceSelection.subscribe((v) => {
      this.generalServiceSingleR = v;
    });

    this.psaService.onRecycleSewerPumpSelection.subscribe((v) => {
      this.sewerPumpR = v;
    });

    this.psaService.onRecycleWaterSelection.subscribe((v) => {
      if (v) this.displayRecycleWater = true;
      else this.displayRecycleWater = false;
      this.recycleWaterSelectedR = v;
    });

    this.psaService.inLinePumpsSelected.subscribe((v: InLinePumps[]) => {
      if (!this.inLinePumpListR) {
        this.inLinePumpListR = [];
      }

      this.inLinePumpListR = v;

      if (this.inLinePumpListR) {
        for (let i = 0; i < this.inLinePumpListR.length; i++) {
          this.inLinePumpListR[i] = new InLinePumps(this.inLinePumpListR[i]);
        }
      }
    });

    this.psaService.totalLots.subscribe((v) => {
      if (v) {
        this.totalLots = v;
      }
    });

    this.psaService.waterServiceDisplay.subscribe((v) => {
      this.waterServicedisplay = v;
    });
    this.psaService.generalServiceDisplay.subscribe((v) => {
      this.generalServicedisplay = v;
    });
    this.psaService.fireServiceDisplay.subscribe((v) => {
      this.fireServicedisplay = v;
    });

    this.numberOfLevelsControl = new FormControl("", Validators.required);
    this.noOfBasementsControl = new FormControl("", Validators.required);
    this.residentialLotsControl = new FormControl("", Validators.required);
    this.industrialLotsControl = new FormControl("", Validators.required);
    this.commercialLotsControl = new FormControl("", Validators.required);
    this.descriptionControl = new FormControl("", [
      Validators.compose([
        Validators.required,
        Validators.maxLength(this.descriptionOfWorkControlMaxLength),
        Validators.pattern(specialCharRE)
      ]),
    ]);

    this.waterServiceSizeControl = new FormControl("", Validators.required);
    this.hydrantFlowRateControl = new FormControl("", Validators.required);
    this.sprinklerFlowRateControl = new FormControl("", Validators.required);
    this.generalServiceSizeControl = new FormControl("", Validators.required);
    this.generalFlowRateControl = new FormControl("", Validators.required);

    this.recycledServiceSizeControl = new FormControl("", Validators.required);
    this.demandControl = new FormControl("", Validators.required);

    this.totalSewerLoadingControl = new FormControl("", Validators.required);
    this.fixtureQuantityControl = new FormControl("");
    this.nonResidentialFloorSpaceControl = new FormControl(
      "" );

    this.residentialLotsGreenFieldControl = new FormControl(
      "",
      Validators.required
    );
    this.residentialdwellingsControl = new FormControl("", Validators.required);
    this.residentialunitsControl = new FormControl("", Validators.required);
    this.commercialLotsHectorsControl = new FormControl(
      "",
      Validators.required
    );
    this.warehouseHectaresControl = new FormControl("", Validators.required);
    this.manfcHectaresControl = new FormControl("", Validators.required);
    this.storeHectaresControl = new FormControl("", Validators.required);

    this.RecyclePump = false;
    //this.addPumpRows(1);
    this.typeOfService = [];
  }

  checkNumberInput(event) {
    this.psaService.applicationData.checkNumber(event);
  }

  RestrictCommaSemicolon(event){
    this.psaService.applicationData.RestrictCommaSemicolon(event);
  }

  get invalid(): boolean {
    if (this.psaService.applicationData.planType === "BrownField") {
      if (
        this.numberOfLevelsControl.invalid ||
        this.noOfBasementsControl.invalid ||
        this.descriptionControl.invalid ||
        this.hydrantFlowRateControl.invalid ||
        this.sprinklerFlowRateControl.invalid ||
        this.generalFlowRateControl.invalid ||
        this.totalSewerLoadingControl.invalid ||
        this.fixtureQuantityControl.invalid ||
        this.nonResidentialFloorSpaceControl.invalid
      ) {
        return true;
      }

      if (!this.workRequestPsa.developmentType) {
        return true;
      }

      if (!this.workRequestPsa.potableWaterServices.waterTappingLocation) {
        return true;
      }

      if (
        this.workRequestPsa.potableWaterServices.waterServiceSize == 0 ||
        this.workRequestPsa.potableWaterServices.generalServiceSize == 0 ||
        !this.workRequestPsa.potableWaterServices.waterServiceSize ||
        !this.workRequestPsa.potableWaterServices.generalServiceSize
      ) {
        return true;
      }

      if (
        !this.workRequestPsa.potableWaterServices.firewaterConnectionType ||
        !this.workRequestPsa.potableWaterServices.generalwaterConnectionType
      ) {
        return true;
      }

      if (!this.inLinePumpR) {
        return true;
      }

      if (this.displayRecycleWater) {
        if (
          this.workRequestPsa.recycledWaterServices.recycledServiceSize == 0 ||
          !this.workRequestPsa.recycledWaterServices.recycledServiceSize
        ) {
          return true;
        }

        if (this.demandControl.invalid) {
          return true;
        }

        if (
          !this.workRequestPsa.recycledWaterServices
            .recycledWaterTappingLocation
        ) {
          return true;
        }
      }
      if (!this.workRequestPsa.sewerServices.sewerConnectionLocation)
        return true;

      if (!this.sewerPumpR) return true;

      if (this.workRequestPsa.potableWaterServices.inLinePumpsUsed) {
        let returnValue = false;
        if (this.inLinePumpList) {
          this.inLinePumpList.map((x) => {
            if (
              x.dutyFlowPerPump === null ||
              x.noOfDutyPumps === null ||
              x.pumpCurve === "" ||
              x.pumpsOperatingTogether === "" ||
              x.purposeWaterSupply === "" ||
              x.standbyPumps === null ||
              x.totalDutyFlow === null
            ) {
              returnValue = true;
            }
          });
          return returnValue;
        }
      }
    }

    if (this.psaService.applicationData.planType === "GreenField") {
      if (!this.workrequestGreenField.developmentType) {
        return true;
      }

      if (
        this.residentialLotsGreenFieldControl.invalid ||
        this.residentialdwellingsControl.invalid ||
        this.residentialunitsControl.invalid ||
        this.commercialLotsHectorsControl.invalid ||
        this.warehouseHectaresControl.invalid ||
        this.manfcHectaresControl.invalid ||
        this.storeHectaresControl.invalid
      ) {
        return true;
      }
    }
  }

  displayErrorMessage(): string[] {
    this.errorMessage = [];

    let errorText = "";
    if (this.psaService.applicationData.planType === "BrownField") {
      if (
        this.numberOfLevelsControl.invalid ||
        this.noOfBasementsControl.invalid ||
        this.descriptionControl.invalid ||
        this.waterServiceSizeControl.invalid ||
        this.hydrantFlowRateControl.invalid ||
        this.sprinklerFlowRateControl.invalid ||
        this.generalServiceSizeControl.invalid ||
        this.generalFlowRateControl.invalid ||
        this.totalSewerLoadingControl.invalid ||
        this.fixtureQuantityControl.invalid ||
        this.nonResidentialFloorSpaceControl.invalid
      ) {
        if (
          this.numberOfLevelsControl.hasError("required") ||
          this.noOfBasementsControl.hasError("required") ||
          this.residentialLotsControl.hasError("required") ||
          this.industrialLotsControl.hasError("required") ||
          this.commercialLotsControl.hasError("required") ||
          this.descriptionControl.hasError("required") ||
          this.hydrantFlowRateControl.hasError("required") ||
          this.sprinklerFlowRateControl.hasError("required") ||
          this.sprinklerFlowRateControl.hasError("required") ||
          this.generalFlowRateControl.hasError("required") ||
          this.totalSewerLoadingControl.hasError("required") ||
          this.fixtureQuantityControl.hasError("required") ||
          this.nonResidentialFloorSpaceControl.hasError("required")
        ) {
          this.errorMessage.push("Please fill the mandatory fields");
          return this.errorMessage;
        }

        if(this.descriptionControl.hasError('pattern'))
        {
          this.errorMessage=["Text can contain following characters only - \ / () ' # . , & "]
        }

      }

      if (this.descriptionControl.hasError("maxlength")) {
        this.errorMessage.push(
          `Description of work cannot exceed ${this.descriptionOfWorkControlMaxLength} characters`
        );
      }

      if (
        this.workRequestPsa.potableWaterServices.waterServiceSize == 0 ||
        this.workRequestPsa.potableWaterServices.generalServiceSize == 0 ||
        !this.workRequestPsa.potableWaterServices.waterServiceSize ||
        !this.workRequestPsa.potableWaterServices.generalServiceSize
      ) {
        this.errorMessage = ["Please fill the mandatory fields"];
        return this.errorMessage;
      }

      if (
        !this.workRequestPsa.developmentType ||
        !this.workRequestPsa.potableWaterServices.firewaterConnectionType ||
        !this.workRequestPsa.potableWaterServices.generalwaterConnectionType ||
        !this.workRequestPsa.potableWaterServices.waterTappingLocation ||
        !this.workRequestPsa.sewerServices.sewerConnectionLocation
      ) {
        this.errorMessage = ["Please fill the mandatory fields"];
        return this.errorMessage;
      }

      if (!this.inLinePumpR) {
        this.errorMessage = ["Please fill the mandatory fields"];
        return this.errorMessage;
      }

      if (!this.sewerPumpR) {
        this.errorMessage = ["Please fill the mandatory fields"];
        return this.errorMessage;
      }

      if (this.displayRecycleWater) {
        if (
          this.workRequestPsa.recycledWaterServices.recycledServiceSize == 0 ||
          !this.workRequestPsa.recycledWaterServices.recycledServiceSize
        ) {
          this.errorMessage = ["Please fill the mandatory fields"];
          return this.errorMessage;
        }

        if (this.demandControl.invalid) {
          this.errorMessage = ["Please fill the mandatory fields"];
          return this.errorMessage;
        }

        if (
          !this.workRequestPsa.recycledWaterServices
            .recycledWaterTappingLocation
        ) {
          this.errorMessage = ["Please fill the mandatory fields"];
          return this.errorMessage;
        }
      }
      if (this.workRequestPsa.potableWaterServices.inLinePumpsUsed) {
        if (this.inLinePumpList) {
          this.inLinePumpList.map((x) => {
            if (
              x.dutyFlowPerPump === null ||
              x.noOfDutyPumps === null ||
              x.pumpCurve === "" ||
              x.pumpsOperatingTogether === "" ||
              x.purposeWaterSupply === "" ||
              x.standbyPumps === null ||
              x.totalDutyFlow === null
            ) {
              this.errorMessage = ["Please fill the mandatory fields"];
              return this.errorMessage;
            }
          });
        }
      }
    }

    if (this.psaService.applicationData.planType === "GreenField") {
      if (
        this.residentialLotsGreenFieldControl.invalid ||
        this.residentialdwellingsControl.invalid ||
        this.residentialunitsControl.invalid ||
        this.commercialLotsHectorsControl.invalid ||
        this.warehouseHectaresControl.invalid ||
        this.manfcHectaresControl.invalid ||
        this.storeHectaresControl.invalid
      ) {
        if (
          this.residentialLotsGreenFieldControl.hasError("required") ||
          this.residentialdwellingsControl.hasError("required") ||
          this.residentialunitsControl.hasError("required") ||
          this.commercialLotsHectorsControl.hasError("required") ||
          this.warehouseHectaresControl.hasError("required") ||
          this.manfcHectaresControl.hasError("required") ||
          this.storeHectaresControl.hasError("required")
        ) {
          this.errorMessage = ["Please fill the mandatory fields"];
        }
      }

      if (!this.workrequestGreenField.developmentType) {
        this.errorMessage = ["Please fill the mandatory fields"];
      }
    }

    this.markValidationControlsAsUntouched();

    return this.errorMessage;
  }

  markValidationControlsAsUntouched() {
    this.numberOfLevelsControl.markAsUntouched();
    this.noOfBasementsControl.markAsUntouched();
    this.residentialLotsControl.markAsUntouched();
    this.industrialLotsControl.markAsUntouched();
    this.commercialLotsControl.markAsUntouched();
    this.descriptionControl.markAsUntouched();

    this.waterServiceSizeControl.markAsUntouched();
    this.hydrantFlowRateControl.markAsUntouched();
    this.sprinklerFlowRateControl.markAsUntouched();
    this.sprinklerFlowRateControl.markAsUntouched();
    this.generalServiceSizeControl.markAsUntouched();
    this.generalFlowRateControl.markAsUntouched();

    this.recycledServiceSizeControl.markAsUntouched();
    this.demandControl.markAsUntouched();

    this.totalSewerLoadingControl.markAsUntouched();
    this.fixtureQuantityControl.markAsUntouched();
    this.nonResidentialFloorSpaceControl.markAsUntouched();
  }

  ngOnInit() {
    this.residentialLotsControl.disable();
    this.industrialLotsControl.disable();
    this.commercialLotsControl.disable();
    const pleaseSelect = [{ id: "0", display: "Please Select..." }];

    this.refDataService
      .retrieveReferenceData(
        RefDataType.SRAServiceSize,
        this.loginService.getToken()
      )
      .subscribe((refDataItems: any) => {
        this.waterServiceSizeValues = pleaseSelect.concat(refDataItems);
        this.generalServiceSizeValues = pleaseSelect.concat(refDataItems);
        this.recycleServiceSizeValues = pleaseSelect.concat(refDataItems);
      });

    this.refDataService
      .retrieveReferenceData(
        RefDataType.SRAPumpCurveType,
        this.loginService.getToken()
      )
      .subscribe((refDataItems: any) => {
        this.pumpCurveOptions = refDataItems;
      });

    this.refDataService
      .retrieveReferenceData(
        RefDataType.SRAWaterSupplyPurpose,
        this.loginService.getToken()
      )
      .subscribe((refDataItems: any) => {
        this.waterSupplyOptions = refDataItems;
      });

    // this.refDataService
    //   .retrievePsaServiceData(this.loginService.getToken())
    //   .subscribe((items) => {
    //     this.waterServiceSizeValues = items.filter((x) => x.type === "water");
    //     this.generalServiceSizeValues = items.filter(
    //       (x) => x.type === "general"
    //     );
    //     this.recycleServiceSizeValues = items.filter(
    //       (x) => x.type === "recycle"
    //     );
    //   });

    // this.refDataService
    //   .retrievePumpCurveData(this.loginService.getToken())
    //   .subscribe((items) => {
    //     this.pumpCurveOptions = items;
    //   });

    // this.refDataService
    //   .retrieveWaterSupplyData(this.loginService.getToken())
    //   .subscribe((items) => {
    //     this.waterSupplyOptions = items;
    //   });
  }

  addPumps(v) {
    this.addPumpRows(v);
  }

  set recycleWaterSelected(v: boolean) {
    this.displayRecycleWater = !this.displayRecycleWater;
    this.psaService.onRecycleWaterSelection.next(v);
  }
  addPumpRows(noOfpumps) {
    if (!this.inLinePumpList) {
      this.inLinePumpList = [];
    }

    let noOfRows: any[] = [];
    for (var i = 1; i <= noOfpumps; i++) {
      const row1: InLinePumps = new InLinePumps();
      row1.pumpCurve = "";
      row1.purposeWaterSupply = "";
      row1.dutyFlowPerPump = null;
      row1.noOfDutyPumps = null;
      row1.standbyPumps = null;
      row1.totalDutyFlow = null;
      row1.pumpsOperatingTogether = "";
      this.inLinePumpList.push(row1);
    }
  }

  get pumpsOperatingTogetherOptions(): SelectItem[] {
    return [
      { label: "Please select...", value: "" },
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ];
  }

  set serviceSingle(v: any) {
    if (v === "yes") {
      this.psaService.applicationData.workRequestPsa.potableWaterServices.firewaterConnectionType =
        "Single";
      this.fireServicedisplay = 1;
    }

    if (v === "no") {
      this.psaService.applicationData.workRequestPsa.potableWaterServices.firewaterConnectionType =
        "Alternate";
      this.fireServicedisplay = 2;
    }

    this.calcWaterServiceDisplay();

    this.psaService.onServiceSingleSelection.next(v);
    this.psaService.fireServiceDisplay.next(this.fireServicedisplay);
  }

  set generalServiceSingle(v: any) {
    if (v === "generalSingle") {
      this.psaService.applicationData.workRequestPsa.potableWaterServices.generalwaterConnectionType =
        "Single";
      this.generalServicedisplay = 1;
    }

    if (v === "generalAlternate") {
      this.psaService.applicationData.workRequestPsa.potableWaterServices.generalwaterConnectionType =
        "Alternate";
      this.generalServicedisplay = 2;
    }

    this.calcWaterServiceDisplay();
    this.psaService.onGeneralServiceSelection.next(v);
    this.psaService.generalServiceDisplay.next(this.generalServicedisplay);
  }
  calcWaterServiceDisplay() {
    if (this.fireServicedisplay === 2 || this.generalServicedisplay === 2) {
      this.waterServicedisplay = 2;
    }

    if (this.fireServicedisplay === 1 && this.generalServicedisplay === 1) {
      this.waterServicedisplay = 1;
    }

    this.psaService.waterServiceDisplay.next(this.waterServicedisplay);
  }

  set inLinePump(v: any) {
    if (v) {
      this.psaService.onInLinePumpSelection.next(v);
    }

    if (v === "inLineYes") {
      this.shouldDisplayCurveTable = true;
      this.addPumpRows(1);
      this.workRequestPsa.potableWaterServices.inLinePumpsUsed = true;
    } else {
      this.shouldDisplayCurveTable = false;
      this.inLinePumpList = [];
      this.workRequestPsa.potableWaterServices.inLinePumpsUsed = false;
    }
  }

  set RecyclePump(v: any) {
    if (v === "true") {
      this.shouldDisplayCurveTableRecycle = true;
    } else {
      this.shouldDisplayCurveTableRecycle = false;
    }
  }

  set waterServiceSize(v: any) {
    this.workRequestPsa.potableWaterServices.waterServiceSize = v;
    this.workRequestPsa.potableWaterServices.fireServiceSize = v;
    let fireService = this.waterServiceSizeValues.find((x) => x.id === v);
    if(fireService)
    this.fireService = fireService.display;
  }

  get waterServiceSize() {
    return this.workRequestPsa.potableWaterServices.waterServiceSize;
  }

  set sewerPump(v: string) {
    if (v) {
      this.psaService.onRecycleSewerPumpSelection.next(v);
    }

    if (v === "internalSewerPumpingYes") {
      this.workRequestPsa.sewerServices.internalSewerPumping = true;
    } else {
      this.workRequestPsa.sewerServices.internalSewerPumping = false;
    }
  }

  get brownFielddevelopmentType() {
    return this.workRequestPsa.developmentType;
  }

  set brownFielddevelopmentType(v: any) {
    if (v) {
      this.psaService.onBrownFielddevelopmentTypeSelection.next(v);
    }

    this.residentialLotsControl.reset();
    this.industrialLotsControl.reset();
    this.commercialLotsControl.reset();
    this.totalLots = 0;

    if (v === "Single Commercial") {
      this.residentialLotsControl.disable();
      this.industrialLotsControl.disable();
      this.commercialLotsControl.enable();
      //this.workRequestPsa.developmentType = "SingleCommercial";
    }

    if (v === "Multi-Unit Residential") {
      this.commercialLotsControl.disable();
      this.industrialLotsControl.disable();
      this.residentialLotsControl.enable();
      //this.workRequestPsa.developmentType = "MultiUnitResidential";
    }
    if (v === "Multi Commercial/Industrial") {
      this.residentialLotsControl.disable();
      this.commercialLotsControl.enable();
      this.industrialLotsControl.enable();
      //this.workRequestPsa.developmentType = "MultiCommercialIndustrial";
    }

    if (v === "Mixed Multi Unit Residential & Commercial") {
      this.industrialLotsControl.disable();
      this.commercialLotsControl.enable();
      this.residentialLotsControl.enable();
      //this.workRequestPsa.developmentType = "MixedMultiUnitResidentialCommercial";
    }

    this.workRequestPsa.developmentType = v;
  }

  set greenFielddevelopmentType(v: string) {
    if (v) {
      this.psaService.onGreenFielddevelopmentTypeSelection.next(v);
    }

    this.residentialLotsGreenFieldControl.reset();
    this.residentialdwellingsControl.reset();
    this.residentialunitsControl.reset();
    this.commercialLotsHectorsControl.reset();
    this.warehouseHectaresControl.reset();
    this.manfcHectaresControl.reset();
    this.storeHectaresControl.reset();

    if (v === "Residential Dwellings") {
      this.residentialLotsGreenFieldControl.enable();
      this.residentialdwellingsControl.enable();
      this.residentialunitsControl.enable();
      this.commercialLotsHectorsControl.disable();
      this.warehouseHectaresControl.disable();
      this.manfcHectaresControl.disable();
      this.storeHectaresControl.disable();
      //this.workrequestGreenField.developmentType = "ResidentialDwellings";
    }

    if (v === "Single Commercial/Industrial") {
      this.residentialLotsGreenFieldControl.disable();
      this.residentialdwellingsControl.disable();
      this.residentialunitsControl.disable();
      this.commercialLotsHectorsControl.enable();
      this.warehouseHectaresControl.enable();
      this.manfcHectaresControl.enable();
      this.storeHectaresControl.enable();
      //this.workrequestGreenField.developmentType = "SingleCommercialIndustrial";
    }
    if (v === "Multi Commercial/Industrial") {
      this.residentialLotsGreenFieldControl.disable();
      this.residentialdwellingsControl.disable();
      this.residentialunitsControl.disable();
      this.commercialLotsHectorsControl.enable();
      this.warehouseHectaresControl.enable();
      this.manfcHectaresControl.enable();
      this.storeHectaresControl.enable();
      //this.workrequestGreenField.developmentType = "MultiCommercialIndustrial";
    }

    if (v === "Mixed Residential Dwellings & Commercial") {
      this.residentialLotsGreenFieldControl.enable();
      this.residentialdwellingsControl.enable();
      this.residentialunitsControl.enable();
      this.commercialLotsHectorsControl.enable();
      this.warehouseHectaresControl.disable();
      this.manfcHectaresControl.disable();
      this.storeHectaresControl.disable();
      //this.workrequestGreenField.developmentType = "MixedResidentialDwellingsCommercial";
    }
    this.workrequestGreenField.developmentType = v;
  }

  selectRow(v, i) {
    if (!this.selectedRow) {
      this.selectedRow = [];
    }

    if (!this.selectedRow.find((x) => x.index === i)) {
      this.selectedRow.push({
        data: v,
        index: i,
      });
    } else {
      this.selectedRow = this.selectedRow.filter((x) => x.index !== i);
    }
  }

  deleteRows() {
    if (this.selectedRow.length > 0) {
      this.selectedRow.map((x) => {
        if (this.inLinePumpList.length > 0) {
          let index = this.inLinePumpList.indexOf(x.data);
          this.inLinePumpList = this.inLinePumpList.filter(
            (val, i) => i !== index
          );
          let index1 = this.selectedRow.indexOf(x);
          this.selectedRow = this.selectedRow.filter((val, i) => i !== index1);
        }
      });
    }
  }

  sum() {
    let value1 = this.workRequestPsa.residentialLots
      ? this.workRequestPsa.residentialLots
      : 0;
    let value2 = this.workRequestPsa.industrialLots
      ? this.workRequestPsa.industrialLots
      : 0;
    let value3 = this.workRequestPsa.commercialLots
      ? this.workRequestPsa.commercialLots
      : 0;

    this.totalLots = value1 + value2 + value3;

    this.psaService.totalLots.next(this.totalLots);
  }

  calculateDemands() {
    if (this.workRequestPsa.potableWaterServices.inLinePumpsUsed) {
      for (var i = 0; i <= this.inLinePumpList.length; i++) {
        if (this.inLinePumpList[i].purposeWaterSupply) {
          if (this.inLinePumpList[i].purposeWaterSupply === "Fire") {
            if (
              this.workRequestPsa.potableWaterServices.hydrantFlowRate ||
              this.workRequestPsa.potableWaterServices.sprinklerFlowRate
            ) {
              this.inLinePumpList[i].dutyFlowPerPump =
                this.workRequestPsa.potableWaterServices.hydrantFlowRate +
                this.workRequestPsa.potableWaterServices.sprinklerFlowRate;
            } else this.inLinePumpList[i].dutyFlowPerPump = null;
          }

          if (this.inLinePumpList[i].purposeWaterSupply === "General") {
            if (this.workRequestPsa.potableWaterServices.generalFlowRate)
              this.inLinePumpList[
                i
              ].dutyFlowPerPump = this.workRequestPsa.potableWaterServices.generalFlowRate;
            else this.inLinePumpList[i].dutyFlowPerPump = null;
          }
        }
      }
    }
  }
 
}



// WEBPACK FOOTER //
// ./src/app/create-application/psa-form/workrequest-psa/workrequest-psa.component.ts